import { useContext } from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { ThemeContext } from 'context/ThemeContext';

import './AppToasts.styles.css';

const AppToasts = ({ }) => {
    const themeCtx = useContext(ThemeContext);

    return (
        <ToastContainer
            position="bottom-left"
            autoClose={5000}
            pauseOnHover
            theme={themeCtx?.theme === 'dark' ? 'dark' : 'light'}
        />
    )
}

export default AppToasts;
